// extracted by mini-css-extract-plugin
export default {"wrapper":"tab-panel-module--wrapper--d6357","selected":"tab-panel-module--selected--32bf0"};